import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const GetDeveleoperVsClientContract = createAsyncThunk(
  "GetDeveleoperVsClientContract",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          url:
            API_URL.BASEURL +
            API_URL?.DIGISIGN?.GET_DEVELOPER_VS_CLIENT_CONTRACT,
          body: data,
        },
        false
      );
      let response = apiResponse(false, resData);

      return response;
    } catch (error) {}
  }
);

export const GetQDLVsDeveloperContract = createAsyncThunk(
  "GetQDLVsDeveloperContract",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          url:
            API_URL.BASEURL +
            API_URL.DIGISIGN?.GET_QDL_VS_DEVELOPER_CONTARACT +
            `?viewtype=${data}`,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);

      return response;
    } catch (error) {}
  }
);

export const GetAllContractList = createAsyncThunk(
  "GetAllContractList",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          url:
            API_URL.BASEURL +
            API_URL.DIGISIGN?.GET_ALL_CONTRACT_LIST +
            `?callingfrom=${data}`,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);

      return response;
    } catch (error) {}
  }
);

const initialState = {
  GetDeveleoperVsClientContractData: {
    data: null,
    error: null,
  },
  GetQDLVsDeveloperContractData: {
    data: null,
    error: null,
  },
  GetAllContractListData: {
    data: null,
    error: null,
  },
};

const DigiSignSlice = createSlice({
  name: "DIGISIGN",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetDeveleoperVsClientContract.fulfilled, (state, action) => {
        state.GetDeveleoperVsClientContractData.data = action.payload;
      })
      .addCase(GetDeveleoperVsClientContract.rejected, (state, action) => {
        state.GetDeveleoperVsClientContractData.error = action.error.message;
      })
      .addCase(GetQDLVsDeveloperContract.fulfilled, (state, action) => {
        state.GetQDLVsDeveloperContractData.data = action.payload;
      })
      .addCase(GetQDLVsDeveloperContract.rejected, (state, action) => {
        state.GetQDLVsDeveloperContractData.error = action.error.message;
      })
      .addCase(GetAllContractList.fulfilled, (state, action) => {
        state.GetAllContractListData.data = action.payload;
      })
      .addCase(GetAllContractList.rejected, (state, action) => {
        state.GetAllContractListData.error = action.error.message;
      });
  },
});

export default DigiSignSlice.reducer;
